export default function Footer() {
    return (
        <footer className="text-white py-4 bg-[#78B5D6]">
            <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
                <section>
                    <h2 className="text-lg font-bold">琴浦町</h2>
                    <p className=" text-smlg text-white text-sm">© 2025 kotoura town</p>
                    <p className="text-sm">鳥取県東伯郡琴浦町大字徳万591-2</p>
                    <p className="text-sm">0858-52-2111</p>
                </section>

                <nav className="flex space-x-4 mt-3 md:mt-0">
                    <a
                        href={`${import.meta.env.VITE_AWS_URL}313718/2025/riyoukiyaku.pdf`}
                        target="_blank"
                        className="text-white hover:opacity-80 text-sm"
                    >
                        利用規約
                    </a>
                    {/* <a href="#" className="text-white hover:opacity-80 text-sm">
                        アクセシビリティ
                    </a>
                    <a href="#" className="text-white hover:opacity-80 text-sm">
                        プライバシーポリシー
                    </a> */}
                </nav>
            </div>
        </footer>
    );
}
